import React, { useEffect, useState } from "react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Wallet } from "lucide-react";

import axios from "axios";
import Switch from "./Switch";
import { useNavigate } from "react-router-dom";
import { MdOutlineClose } from "react-icons/md";



const navigation = [
  { name: "Dashboard", href: "#", current: true },
  { name: "Team", href: "#", current: false },
  { name: "Projects", href: "#", current: false },
  { name: "Calendar", href: "#", current: false },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const Navbar = ({ activeTab, toggleTab }) => {
  const navigate = useNavigate();
  const [availableCredit, setAvailableCredit] = useState(0); // Store credit balance
  const [distributedCredit, setDistributedCredit] = useState(0); // Store credit balance
  const [loading, setLoading] = useState(true); // Loading state
  const storedRole = localStorage.getItem("role");
  const storedName = localStorage.getItem("name");
  const storedAvatar = localStorage.getItem("avatar");
  const storedEmail = localStorage.getItem("email");
  useEffect(() => {
    fetchavailableCredit();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    navigate("/login");
  };
  const userRole = localStorage.getItem("role"); // Get user ID from localStorage
  const fetchavailableCredit = async () => {
    try {
      const userId = localStorage.getItem("uid"); // Get user ID from localStorage
      const token = localStorage.getItem("token"); // Get token if needed

      if (!userId) {
        console.error("User ID not found in localStorage");
        return;
      }
      console.log(userId);
      const response = await axios.get(
        `https://api.trubetx.com/admin/getCredit/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // If authentication is required
          },
        }
      );
      console.log("first");
      console.log(response);
      setAvailableCredit(response.data.available_credit || 0); // Update state with API response
      setDistributedCredit(response.data.total_distributed_credit || 0); // Update state with API response
    } catch (error) {
      console.error("Error fetching credit balance:", error);
      setAvailableCredit(0); // Set to 0 in case of an error
    } finally {
      setLoading(false); // Stop loading
    }
  };

  
  const [isOpen, setIsOpen] = useState(false);
 
  return (
    <Disclosure
      as="nav"
      className="bg-white"
      style={{ position: "fixed", top: 0, left: 0, right: 0 }}
    >
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
        
          <div className="flex flex-1 items-center justify-center md:items-stretch md:justify-start"></div>

          <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
           
         <div className="flex flex-1 justify-end gap-3">
          <div className="hidden max-w-max  sm:block">
            <div className=" bg-gray-100  flex-1 justify-between divide-y-2 divide-neutral-300 rounded-lg  px-2 py-2 sm:flex sm:divide-x-2 sm:divide-y-0 undefined">
              <div className="flex flex-1 items-center gap-1.5 px-3 py-2 text-center sm:py-0">
                <h3 className="text-xs uppercase"> Cash</h3>
                <div className="font-semibold">{userRole === "admin" ? (
                  <span className="font-semibold">∞</span>
                ) : (
                  `$ ${availableCredit}`
                )}</div>
              </div>
              <div className="flex flex-1 items-center gap-1.5 px-3 py-2 text-center sm:py-0">
                <h3 className="text-xs uppercase"> Coins</h3>
                <div className=" font-semibold">{userRole === "admin" ? (
                  <span className="font-semibold">∞</span>
                ) : (
                  `$ ${availableCredit}`
                )}</div>
              </div>
            </div>
          </div>
          <button
            className="mantine-UnstyledButton-root relative mantine-auidlw"
            type="button"
          >
            <div className="text-xl text-neutral-800">
              <div className="relative">
                <div  onClick={() => setIsOpen(true)} className="flex h-5 w-5 items-center justify-center rounded-full bg-neutral-200 p-3.5 text-xs">
                  r
                </div>
              </div>
            </div>
          </button>
          <span
            aria-haspopup="dialog"
            aria-expanded="false"
            aria-controls="mantine-rf-dropdown"
            id="mantine-rf-target"
            className=" css-0"
          >
            {" "}
            <div className="  flex h-full items-center  ">
              <div className="relative">
                <svg
                  stroke="currentColor"
                  fill="none"
                  strokeWidth={0}
                  viewBox="0 0 24 24"
                  className=" text-xl"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 3V3.28988C16.8915 4.15043 19 6.82898 19 10V17H20V19H4V17H5V10C5 6.82898 7.10851 4.15043 10 3.28988V3C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3ZM7 17H17V10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10V17ZM14 21V20H10V21C10 22.1046 10.8954 23 12 23C13.1046 23 14 22.1046 14 21Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
          </span>
        </div>

            {/* Profile dropdown */}
            <Menu as="div" className="relative ml-3">
              
              {/* <MenuItems
                transition
                style={{zIndex:"20000"}}
                className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-gray-700 py-1 ring-1 shadow-lg ring-black/5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
              >
                <MenuItem>
                  <a 
                   
                    className="block px-4 py-2 text-sm text-white data-focus:bg-gray-100 data-focus:outline-hidden cursor-pointer"
                 
                  >
                    Your Profile
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-white data-focus:bg-gray-100 data-focus:outline-hidden cursor-pointer"
                  >
                    Settings
                  </a>
                </MenuItem>
                <MenuItem>
                  <a
                    className="block px-4 py-2 text-sm text-white data-focus:bg-gray-100 data-focus:outline-hidden cursor-pointer"
                    onClick={()=>handleLogout()}
                  >
                    Sign out
                  </a>
                </MenuItem>
              </MenuItems> */}
              {isOpen && (
                <div
  className="fixed top-0 right-0 h-full w-full max-w-[300px] sm:max-w-[350px] md:max-w-[350px] bg-white shadow-lg transition-transform transform translate-x-0 overflow-y-auto"
  style={{ zIndex: '9999999' }}
>
  {/* Close Button */}
  <button
    onClick={() => setIsOpen(false)}
    className="absolute top-4 right-4 text-black hover:bg-gray-200 p-2 rounded-full text-xl"
  >
    <MdOutlineClose />
  </button>

  {/* Profile Content */}
  <div className="p-6 pt-[20px] text-center space-y-5">
    {/* Avatar */}
    <div className="mx-auto w-[50px] h-[50px] bg-gray-300 rounded-full flex items-center justify-center text-xl font-semibold uppercase text-white">
      r
    </div>

    <div>
      <h2 className="font-medium text-lg">{storedName}</h2>
      <p className="text-sm text-gray-500 capitalize">{storedRole}</p>
      <p className="text-sm text-gray-500">
       {storedEmail}
      </p>
    </div>

    {/* Buttons */}
    <div className="flex flex-col sm:flex-row justify-center gap-3">
      <button
        onClick={() => navigate("/profile")}
        className="bg-blue-500 text-white px-3 py-1 rounded"
      >
        My Profile
      </button>
      <button
        onClick={() => navigate("/setting")}
        className="bg-blue-500 text-white px-3 py-1 rounded"
      >
       Settings
      </button>
    </div>

    {/* Cash & Coins */}
    <div className="flex justify-between items-center bg-gray-100 px-3 py-2 rounded text-sm sm:text-base">
      <span>
        Coins: <strong> {userRole === "admin" ? (
                 <span style={{fontSize:"20px"}}>∞</span> 
                ) : (
                  `$ ${availableCredit}`
                )}</strong>
      </span>
      <span>|</span>
      <span>
        Distributed coins: <strong>{distributedCredit}</strong>
      </span>
    </div>

    {/* Logout */}
    <button
      onClick={handleLogout}
      className="bg-red-500 text-white px-2 py-1 rounded flex items-center justify-center "
    >
      Log Out
    </button>
  </div>
</div>

              )}
            </Menu>
          </div>
        </div>
      </div>
    </Disclosure>
  );
};

export default Navbar;
